export function createTicketSnapshotDataUrl({
  ticketCode,
  subject,
  status,
  priority,
  category,
  requesterName,
  requesterDni,
  requesterEmail,
  createdAt,
  department,
}) {
  const canvas = document.createElement('canvas');
  canvas.width = 900;
  canvas.height = 520;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  const bg = '#FFFFFF';
  const border = '#E5E7EB';
  const orange = '#F07E2D';
  const text = '#111827';
  const muted = '#6B7280';

  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = border;
  ctx.fillRect(0, 0, canvas.width, 1);
  ctx.fillRect(0, canvas.height - 1, canvas.width, 1);
  ctx.fillRect(0, 0, 1, canvas.height);
  ctx.fillRect(canvas.width - 1, 0, 1, canvas.height);

  ctx.fillStyle = orange;
  ctx.fillRect(0, 0, canvas.width, 84);

  ctx.fillStyle = '#FFFFFF';
  ctx.font = '700 22px Arial';
  ctx.fillText('MESA DE AYUDA', 24, 34);
  ctx.font = '700 28px Arial';
  ctx.fillText(ticketCode || 'TK-000', 24, 68);

  const pill = (x, y, label, fill, stroke, color) => {
    const padX = 12;
    ctx.font = '700 14px Arial';
    const w = ctx.measureText(label).width + padX * 2;
    const h = 30;
    ctx.fillStyle = fill;
    roundRect(ctx, x, y, w, h, 999);
    ctx.fill();
    ctx.strokeStyle = stroke;
    ctx.lineWidth = 1;
    roundRect(ctx, x, y, w, h, 999);
    ctx.stroke();
    ctx.fillStyle = color;
    ctx.fillText(label, x + padX, y + 20);
    return w;
  };

  const roundRect = (c, x, y, w, h, r) => {
    const rr = Math.min(r, w / 2, h / 2);
    c.beginPath();
    c.moveTo(x + rr, y);
    c.arcTo(x + w, y, x + w, y + h, rr);
    c.arcTo(x + w, y + h, x, y + h, rr);
    c.arcTo(x, y + h, x, y, rr);
    c.arcTo(x, y, x + w, y, rr);
    c.closePath();
  };

  let px = 24;
  const py = 96;
  const st = String(status || 'Abierto').trim();
  const pr = String(priority || 'Media').trim();
  const cat = String(category || 'General').trim();
  px += pill(px, py, st, '#EFF6FF', '#BFDBFE', '#1D4ED8') + 10;
  px += pill(px, py, pr, pr === 'Alta' ? '#FEF2F2' : pr === 'Baja' ? '#F0FDF4' : '#FFFBEB', pr === 'Alta' ? '#FECACA' : pr === 'Baja' ? '#BBF7D0' : '#FDE68A', pr === 'Alta' ? '#B91C1C' : pr === 'Baja' ? '#15803D' : '#92400E') + 10;
  pill(px, py, cat, '#F9FAFB', '#E5E7EB', '#374151');

  ctx.fillStyle = text;
  ctx.font = '700 22px Arial';
  wrapText(ctx, String(subject || '').trim(), 24, 162, 852, 28, 2);

  ctx.fillStyle = muted;
  ctx.font = '400 14px Arial';
  const line1 = `Solicitante: ${String(requesterName || '').trim()} (${String(requesterDni || '').trim()})`;
  const line2 = `Correo: ${String(requesterEmail || '').trim()}`;
  const line3 = department ? `Área/Departamento: ${String(department).trim()}` : '';
  const line4 = createdAt ? `Fecha: ${String(createdAt).trim()}` : '';
  ctx.fillText(line1, 24, 232);
  ctx.fillText(line2, 24, 255);
  if (line3) ctx.fillText(line3, 24, 278);
  if (line4) ctx.fillText(line4, 24, 301);

  return canvas.toDataURL('image/png');
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
  const words = String(text || '').split(/\s+/).filter(Boolean);
  const lines = [];
  let line = '';
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width <= maxWidth) {
      line = test;
    } else {
      lines.push(line);
      line = w;
      if (maxLines && lines.length >= maxLines) break;
    }
  }
  if (line && (!maxLines || lines.length < maxLines)) lines.push(line);
  const out = maxLines ? lines.slice(0, maxLines) : lines;
  out.forEach((ln, i) => ctx.fillText(ln, x, y + i * lineHeight));
}
